import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Text, useTheme } from '@ui-kitten/components';
import lodashPick from 'lodash/pick';

import constants from '../../Config/constants';
import MenuItemHelper from '../../Helper/MenuItem';
import { getCurrency } from '../../Helper/Routines';
import ThemeStyle from '../../Theme/styles';

import Button from '../Button';
import QuickCart from '../QuickCart';
import ScaleButtonAnimation from '../Web/Intereaction/ScaleButtonAnimation';

import BaseCard from './';
import { itemMediumProps } from './itemPropCheck';
import ItemTag from './ItemTag';
import styles, { ids, titleProps, subTitleProps } from './styles';

function ItemMedium({
  containerStyle,
  isMealPlan,
  tags,
  onError,
  onPress,
  order_date,
  ...itemInfo
}) {
  const { discounted_price, image, name, price, regular_price, stock } =
    itemInfo;
  const hasDiscount = MenuItemHelper.hasDiscount(
    lodashPick(itemInfo, [
      'active_discount',
      'discount_type',
      'discount_value',
    ]),
  );
  const remaining = MenuItemHelper.getCategoryOrItemStock(
    lodashPick(itemInfo, [
      'item_limit_per_day',
      'item_limit_per_time_slot',
      'stock',
      'category_stock',
    ]),
  );
  const store_theme = useTheme();

  const disabled = stock === 0;

  const ClickableComponent = constants.isWeb ? ScaleButtonAnimation : Button;
  return (
    <ClickableComponent
      disabled={disabled}
      dataSet={{ media: ids.itemMediumContainer }}
      onPress={onPress}
      style={[styles.itemMediumContainer, StyleSheet.flatten(containerStyle)]} // mobile style
      buttonStyle={[
        styles.itemMediumContainer,
        StyleSheet.flatten(containerStyle),
      ]} // web style
      plain
    >
      <View style={ThemeStyle.spacingBottomSmall}>
        {/* Item image */}
        <BaseCard
          image={image}
          imageStyle={{ aspectRatio: 1 / 1 }}
          imageOverlay={
            <ItemTag
              stock={itemInfo.stock}
              tags={tags}
              style={[
                ThemeStyle.spacingTopMedium,
                ThemeStyle.spacingRightMedium,
                ThemeStyle.flexDirectionRowEnd,
              ]}
            />
          }
        />
        {/* show quick cart if not disabled */}
        {!disabled && (
          <QuickCart
            item={itemInfo}
            onError={onError}
            store_theme={store_theme}
          />
        )}
      </View>
      {/* Item name */}
      <Text {...titleProps} numberOfLines={2}>
        {name}
      </Text>
      {/* Item price or original price and compare price if has discount */}
      {!isMealPlan && (
        <View style={[ThemeStyle.flexWrap, ThemeStyle.flexDirectionRowCenter]}>
          <Text
            {...subTitleProps}
            style={[
              subTitleProps.style,
              ThemeStyle.spacingRightSmall,
              hasDiscount && ThemeStyle.strikethrough,
            ]}
          >
            {getCurrency(Number(hasDiscount ? regular_price : price))}
          </Text>
          {hasDiscount && (
            <Text
              {...titleProps}
              style={[titleProps.style, ThemeStyle.noticeText]}
            >
              {getCurrency(Number(discounted_price))}
            </Text>
          )}
        </View>
      )}
      {/* Item remaining */}
      {Boolean(remaining) && (
        <Text
          {...subTitleProps}
          style={[subTitleProps.style, ThemeStyle.noticeText]}
        >
          {remaining} items left!
        </Text>
      )}
    </ClickableComponent>
  );
}

ItemMedium.propTypes = itemMediumProps;

export default ItemMedium;
